import Base from '../../../Base/Base';
import Styles from './RequestProcessing.module.scss';
import Grid from '@mui/material/Grid';
import { WQAccordion } from '../../../../components/UI/WQAccordion/WQAccordion';
import { ReactElement, useContext, useEffect, useState } from 'react';
import AppProcessingForm from './AppProcessingForm';
import {
	fetchRequestInformation,
	fetchAppsForProcessing,
	fetchOtherApplications,
} from './RequestProcessing_api';
import { Button } from '@upmc/ims.component-library';
import { approveAllRequestsSelected } from '../WorkQueue/WorkQueueResults_api';
import RequestInformation from './RequestInformation';
import { UserContext } from 'context/User/UserContext';
import {
	Subtitle1,
	Headline5,
	Subtitle2,
} from './../../../../components/UI/MDC/Typography/Typography';
import OtherApplications from './OtherApplications.component';
import MaterialIcon from '@material/react-material-icon';
import IconButton from '@mui/material/IconButton';
import CircularProgress from '@mui/material/CircularProgress';
import ContentCopyIcon from '@mui/icons-material/ContentCopy';
import Tooltip from '@mui/material/Tooltip';
import WithLoadingHandler from '../../../../hoc/withLoadingHandler/withLoadingHandler';
import { useLocation, useHistory } from 'react-router-dom';
import { useSelector, useDispatch } from 'react-redux';
import { deepCloneObject } from '../../../../store/utility';
import ArrowForwardIosNewIcon from '@mui/icons-material/ArrowForwardIos';
import ArrowBackwardIosNewIcon from '@mui/icons-material/ArrowBackIosNew';
import { setRows } from '../../../../store/workQueue/actions';
import { isEmpty } from 'lodash';

/**
 * Wrapping component for Request Processing Page
 *
 * @returns {ReactElement} rendered component.
 */

const RequestProcessing = () => {
	const [requestee, setRequestee] = useState(undefined);
	const [requestor, setRequestor] = useState(undefined);
	const [assignee, setAssignee] = useState(undefined);
	const [applications, setApplications] = useState(null);
	const [otherApps, setOtherApps] = useState(null);
	const [processing, setProcessing] = useState(false);
	const [openTooltip, setOpenTooltip] = useState(false);
	const [appsForProcessingExpanded, setAppsForProcessingExpanded] =
		useState(true);
	const [isLoadingApps, setIsloadingApps] = useState(true);
	const [isLoadingOtherApps, setIsLoadingOtherApps] = useState(true);
	const workQueueRows = useSelector(state => state.workQueue.rows);
	const dispatch = useDispatch();
	const history = useHistory();
	const [ableToProcess, setAbleToProcess] = useState(true);
	const [assignedToSelf, setAssignedToSelf] = useState(undefined);
	const [waitAfterProcessing, setWaitAfterProcessing] = useState(false);
	const [hasValidActionSelected, setHasValidActionSelected] = useState(false);

	if (!!!workQueueRows || workQueueRows.length === 0) {
		history.goBack();
	}

	/**
	 * @type {import('context/User/UserContext').ContextUser}
	 */
	const contextUser = useContext(UserContext);
	const user =
		contextUser.userInfo.impersonationProfile ??
		contextUser.userInfo.userProfile;

	const validateApplications = () => {
		if (applications) {
			for (let application of applications) {
				const action = application.selectedAction?.F_Short;
				const comments = application.ApplicationComments;

				// Check for admin comments on action Unable to Process and Declined
				// Check to make sure username is filled in unless the action is declinded
				// Return false to invalidate and not allow user to submit
				if (
					(action &&
						(action === 'Unable To Process' ||
							action === 'Declined') &&
						(!comments || comments.length < 1)) ||
					(action &&
						action !== 'Declined' &&
						action !== 'Select action' && // If action is Declined, or nothing selected yet, we don't need to require username
						(application?.AccountInfo?.F_Account_Username ===
							null ||
							application?.AccountInfo?.F_Account_Username ===
								''))
				) {
					return false;
				}
			}
			return true;
		}
	};

	useEffect(() => {
		window.scrollTo(0, 0);
	}, []);

	useEffect(() => {
		const isValid = validateApplications();
		if (!isValid) {
			setAbleToProcess(false);
		} else {
			setAbleToProcess(true);
		}
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, [applications]);

	useEffect(() => {
		if (assignee !== undefined && user.ID) {
			if (assignee === null || assignee?.eso_id === user.ID) {
				setAssignedToSelf(true);
			} else {
				setAssignedToSelf(false);
			}
		}
	}, [assignee, user]);

	// Access search parameters
	const location = useLocation();
	const params = new URLSearchParams(location.search);
	const SystemName = params.get('SystemName');
	const SystemID = params.get('SystemID');
	const TrackingNumber = params.get('TrackingNumber');
	const wqReport = params.get('wqReport');

	// Access state
	const appIDs =
		location?.state?.appIDs ??
		params
			.get('appIDs')
			.split(',')
			.filter(Boolean)
			.map(s => parseInt(s.trim()));
	const itemIDs =
		location?.state?.itemIDs ??
		params
			.get('itemIDs')
			.split(',')
			.filter(Boolean)
			.map(s => parseInt(s.trim()));
	const row = location?.state?.row !== null ? location?.state?.row : '';

	const [error, setError] = useState(undefined);

	const [obj, setObj] = useState({
		TrackingNumber: TrackingNumber,
		AppIDs: appIDs,
		systemID: SystemID,
	});

	const updateAppByID = (ID, newData) => {
		const updatedItems = applications?.map(app => {
			if (app.AppID === ID) {
				return { ...newData };
			}
			return app;
		});

		// Add a check every time the applications are updated to check for a valid action on all applications
		// If at least one application has a valid action selected, then allow to process
		if (
			updatedItems?.some(
				app =>
					app.selectedAction?.F_Short !== 'Select action' &&
					!isEmpty(app.selectedAction?.F_Short)
			)
		) {
			setHasValidActionSelected(true);
		} else {
			setHasValidActionSelected(false);
		}
		setApplications(updatedItems);
	};

	useEffect(() => {
		if (
			applications?.filter(
				app => app?.AccountInfo?.status?.toLowerCase() !== 'completed'
			)?.length === 0
		) {
			setAppsForProcessingExpanded(false);
		}
	}, [applications]);
	/**
	 * Completes all the selected requests
	 *
	 * @returns void
	 */
	const ProcessAllSelected = () => {
		setError(undefined);
		if (ableToProcess === true) {
			var argsAPI = {
				T_ESO_FI_ID: user.ID,
				RequestList: [],
			};
			// Generated csv wth app IDs
			let appIDs = row.Cells.ApplicationID.Value.split(',').map(appID =>
				appID.toString()
			);

			// Generated csv wth app names
			let appNames = row.Cells.Application.Value.split(',').map(appID =>
				appID.toString()
			);

			// Generated csv wth work queue names
			let queueNames = row.Cells['Queue Name'].Value.split(',').map(
				appID => appID.toString()
			);

			// Use that appIDs index and create the application object while adding the other associated values to the object
			appIDs.forEach((appID, genericIndex) => {
				const foundApp = applications.find(
					app => Number(app.AppID) === Number(appID)
				);

				// Same as account admin comments
				const applicationComments = foundApp
					? foundApp?.ApplicationComments
					: null;

				// Request adjustment comments
				const requestAdjustmentComments = foundApp
					? foundApp?.RequestAdjustmentComments
					: null;

				// Same as Approver Comments
				const internalComments = foundApp
					? foundApp?.CrossSystemComments
					: null;

				const username = foundApp
					? foundApp?.AccountInfo?.F_Account_Username
					: null;

				const password = foundApp
					? foundApp?.AccountInfo?.F_Account_Password
					: null;

				// Action selected
				const actionSelected = foundApp ? foundApp.selectedAction : {};

				if (
					actionSelected?.F_Short !== 'Select action' &&
					!isEmpty(actionSelected)
				) {
					return argsAPI.RequestList.push({
						TrackingNumber: row.Cells['Tracking Number'].Value,
						Application: {
							ID: appID,
							Name: appNames[genericIndex],
							WorkQueueName: queueNames[genericIndex],
							WorkQueueID:
								row.Cells['WorkQueueID'].Value.split(
									','
								)[0].trim(),
						},
						AcctAdminComments: applicationComments,
						RequestAdjustmentComments: requestAdjustmentComments,
						InternalComments: internalComments,
						Action: actionSelected,
						Username: username,
						Password: password,
					});
				} else {
					return null;
				}
			});

			setProcessing(true);
			approveAllRequestsSelected(argsAPI).then(resp => {
				var approvedRequests = resp?.data?.payload?.ApprovedAllRequests;
				if (approvedRequests) {
					const idsToRemove = argsAPI.RequestList.map(request =>
						Number(request.Application.ID)
					);

					setObj({
						...obj,
						AppIDs: obj?.AppIDs.filter(
							appID => !idsToRemove.includes(appID)
						),
					});
					// Set complete message and change icon to check mark because it was success
					// Wait 3 seconds before going to next request(setting process to false)
					setWaitAfterProcessing(true);
					setTimeout(() => {
						setWaitAfterProcessing(false);
						setProcessing(false);
					}, 3000);
				} else {
					setError(resp?.error);
					// TODO: need to display error message on screen
					// Also add to message that the user needs to manually click on prev/next buttons
				}
			});
		}
	};

	useEffect(() => {
		if (processing === false) {
			fetchRequestInformation(obj).then(resp => {
				if (resp?.data?.responseCode !== 200) {
					setError(resp?.data?.messages);
				} else {
					setRequestee(resp?.data?.payload?.RequesteeInfo);
					setRequestor(resp?.data?.payload?.RequestorInfo);
					setAssignee(resp?.data?.payload?.AssigneeInfo);
				}
			});

			fetchAppsForProcessing(obj).then(resp => {
				if (resp?.data?.responseCode !== 200) {
					setError(resp?.data?.messages);
				} else {
					let apps = resp?.data?.payload;

					// If we get back 0 apps, then we can remove row from list and auto push to next in queue
					if (apps?.length === 0 && workQueueRows.length > 0) {
						var index = workQueueRows.findIndex(row => {
							return (
								row?.Cells['Tracking Number']?.Value &&
								row?.Cells['Tracking Number']?.Value ===
									TrackingNumber
							);
						});

						if (workQueueRows.length === 1) {
							index = -1;
						}

						var newRow;

						if (index === 1 && workQueueRows.length === 2) {
							newRow = deepCloneObject(workQueueRows[0]);
						} else if (workQueueRows.length - 1 === index) {
							newRow = deepCloneObject(workQueueRows[index - 1]);
						} else {
							newRow = deepCloneObject(workQueueRows[index + 1]);
						}

						Object.keys(newRow.Cells).map(key => {
							// Remove the onclick on rows because we can't send non-serializable data like functions via state
							// Also, we won't be using this data anyway so it's not necessary to keep
							if (newRow.Cells[key].props) {
								delete newRow.Cells[key].props.onClick;
							}
							if (key === 'Tracking Number') {
								delete newRow.Cells[key].props.cellTextOnClick;
							}
							return true;
						});

						const newState = {
							appIDs: newRow.Cells['ApplicationID'].Value.split(
								','
							).map(Number),
							itemIDs:
								newRow.Cells['ItemID'].Value.split(',').map(
									Number
								),
							row: newRow,
						};

						// Remove old row from wq rows if we have 0 apps left to process
						var newRows = workQueueRows.filter(
							workQueueRow =>
								workQueueRow.Cells['Tracking Number'].Value !==
								row.Cells['Tracking Number'].Value
						);
						dispatch(setRows([...newRows]));

						// Only navigate to next request IF there is a next request
						if (newRows.length > 0) {
							// Navigate to new tracking number/request
							history.replace({
								pathname: `/workqueue/Request/${newRow.Cells['Tracking Number'].Value}`,
								search: `?TrackingNumber=${newRow.Cells['Tracking Number'].Value}&SystemName=${SystemName}&SystemID=${SystemID}`,
								state: newState,
							});
						}
					}

					setApplications(
						apps?.map(app => {
							return { ...app, selectedAction: {} };
						})
					);
				}
				setIsloadingApps(false);
			});

			setIsLoadingOtherApps(true);

			let otherAppsObj = { ...obj };
			otherAppsObj.wqReport = wqReport ? true : false;

			fetchOtherApplications(otherAppsObj).then(resp => {
				if (resp?.data?.responseCode !== 200) {
					setError(resp?.data?.messages);
				} else {
					setOtherApps(resp?.data?.payload);
				}
				setIsLoadingOtherApps(false);
			});
		}
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, [processing]);

	return (
		<Base title={'Processing Request'} className={Styles['base--default']}>
			<Headline5 className={Styles['text--align--center']}>
				<b>{SystemName}</b>
			</Headline5>
			{workQueueRows.length === 0 && !wqReport ? (
				<Subtitle1 className={Styles['text--align--norequests']}>
					There are no requests left in this Work Queue
				</Subtitle1>
			) : (
				<>
					<Subtitle1 className={Styles['text--align--center']}>
						<b>
							{TrackingNumber}
							<Tooltip
								title='Copied Successfully!'
								open={openTooltip}
								onClose={() => setOpenTooltip(false)}
								onClick={() => {
									navigator.clipboard
										.writeText(TrackingNumber)
										.then(() => {
											// Show tooltip
											setOpenTooltip(true);
											// Hide tooltip after 2 seconds
											setTimeout(() => {
												setOpenTooltip(false);
											}, 2000);
										});
									navigator.clipboard.writeText(
										TrackingNumber
									);
								}}
							>
								<IconButton aria-label='copy'>
									<ContentCopyIcon />
								</IconButton>
							</Tooltip>
						</b>
					</Subtitle1>
					<Grid container spacing={3}>
						<Grid item xs={12} sm={12} md={6} lg={6} xl={6}>
							<WQAccordion
								defaultExpanded={true}
								title={'Requested For'}
								subTitle={requestee?.f_full}
							>
								<RequestInformation requestInfo={requestee} />
							</WQAccordion>
						</Grid>
						<Grid item xs={12} sm={12} md={6} lg={6} xl={6}>
							<WQAccordion
								defaultExpanded={true}
								title={'Requested By'}
								subTitle={requestor?.f_full}
							>
								<RequestInformation
									requestInfo={requestor}
									requestor
								/>
							</WQAccordion>
							<WQAccordion
								className={
									assignee?.eso_id &&
									assignee?.eso_id !== user.ID
										? Styles[
												'accordion--background--notSelfAssign'
										  ]
										: null
								}
								defaultExpanded={false}
								title={'Assigned To'}
								subTitle={assignee?.f_full ?? 'Not Assigned'}
							>
								<RequestInformation
									requestInfo={assignee}
									assignInfo={true}
								/>
							</WQAccordion>
						</Grid>
						<Grid item xs={12} sm={12} md={12} lg={12} xl={12}>
							<WQAccordion
								defaultExpanded={appsForProcessingExpanded}
								title={`Applications Available For Processing (${
									applications?.filter(app =>
										wqReport
											? app
											: app?.AccountInfo?.status?.toLowerCase() !==
											  'completed'
									)?.length ?? 0
								})`}
								subTitle={
									'Perform actions on applications requested for processing'
								}
							>
								<WithLoadingHandler
									isLoading={isLoadingApps}
									showChildren={!isLoadingApps}
								>
									<Grid
										container
										spacing={2}
										alignContent='center'
										alignItems='center'
										alignSelf='center'
									>
										{applications
											?.filter(app =>
												wqReport
													? app
													: app?.AccountInfo?.status?.toLowerCase() !==
													  'completed'
											)
											.map((app, index) => (
												<Grid
													item
													xs={12}
													sm={12}
													md={12}
													lg={12}
													xl={12}
												>
													<AppProcessingForm
														{...{
															updateAppByID,
															wqReport,
														}}
														key={app.Value}
														itemID={itemIDs[index]}
														{...{
															app,
														}}
													/>
												</Grid>
											))}
										{applications?.filter(
											app =>
												app?.AccountInfo?.status?.toLowerCase() !==
												'completed'
										)?.length > 0 &&
											applications?.some(
												app => app.Actionable === true
											) &&
											assignedToSelf &&
											!wqReport && (
												<Grid
													item
													sx={{ margin: 'auto' }}
												>
													<Button
														color={
															waitAfterProcessing
																? 'success'
																: 'primary'
														}
														disabled={
															!hasValidActionSelected ||
															(processing &&
																error ===
																	undefined &&
																!waitAfterProcessing)
														}
														startIcon={
															processing &&
															error ===
																undefined &&
															!waitAfterProcessing ? (
																<CircularProgress
																	size={24}
																/>
															) : (
																<MaterialIcon
																	icon={
																		ableToProcess &&
																		!waitAfterProcessing
																			? 'save'
																			: waitAfterProcessing
																			? 'check'
																			: 'error'
																	}
																/>
															)
														}
														icon={
															<MaterialIcon
																icon={
																	ableToProcess &&
																	!waitAfterProcessing
																		? 'save'
																		: waitAfterProcessing
																		? 'check'
																		: 'error'
																}
															/>
														}
														variant={
															waitAfterProcessing
																? 'contained'
																: 'outlined'
														}
														onClick={() =>
															!processing &&
															!waitAfterProcessing &&
															ProcessAllSelected()
														}
														id='FavUpdateCancel-Top'
													>
														{waitAfterProcessing
															? 'Success'
															: 'Process'}
													</Button>
												</Grid>
											)}
									</Grid>
								</WithLoadingHandler>
								<Grid container spacing={2}>
									<Grid item sx={{ margin: 'auto' }}>
										<Subtitle2
											className={
												Styles['error--text-default']
											}
										>
											{error}
										</Subtitle2>
									</Grid>
								</Grid>
							</WQAccordion>
						</Grid>
						{!wqReport && (
							<PrevNext
								{...{ TrackingNumber, SystemID, SystemName }}
							/>
						)}
						<Grid item xs={12} sm={12} md={12} lg={12} xl={12}>
							<WQAccordion
								defaultExpanded={false}
								title={`Other Applications (${otherApps?.length})`}
								subTitle={'Other processed applications'}
							>
								<WithLoadingHandler
									isLoading={isLoadingOtherApps}
									showChildren={!isLoadingOtherApps}
								>
									<OtherApplications
										{...{ otherApps, wqReport }}
									/>
								</WithLoadingHandler>
							</WQAccordion>
						</Grid>
					</Grid>
				</>
			)}
		</Base>
	);
};

const PrevNext = ({ TrackingNumber, SystemID, SystemName }) => {
	const workQueueRows = useSelector(state => state.workQueue.rows);
	const [requestIndex, setRequestIndex] = useState();
	const history = useHistory();

	useEffect(() => {
		const index = workQueueRows.findIndex(row => {
			return (
				row?.Cells['Tracking Number']?.Value &&
				row?.Cells['Tracking Number']?.Value === TrackingNumber
			);
		});

		setRequestIndex(index);
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, []);

	const handlePrevNext = direction => {
		if (requestIndex === -1) {
			alert('An error has occurred in finding the correct request.');
		} else {
			const row =
				direction === 'prev'
					? workQueueRows[requestIndex - 1]
					: direction === 'next'
					? workQueueRows[requestIndex + 1]
					: workQueueRows[requestIndex];

			let newRow = deepCloneObject(row);

			Object.keys(newRow.Cells).map(key => {
				// Remove the onclick on rows because we can't send non-serializable data like functions via state
				// Also, we won't be using this data anyway so it's not necessary to keep
				if (newRow.Cells[key].props) {
					delete newRow.Cells[key].props.onClick;
				}
				if (key === 'Tracking Number') {
					delete newRow.Cells[key].props.cellTextOnClick;
				}
				return true;
			});

			const newState = {
				appIDs: newRow.Cells['ApplicationID'].Value.split(',').map(
					Number
				),
				itemIDs: newRow.Cells['ItemID'].Value.split(',').map(Number),
				row: newRow,
			};

			// Need to get first element of string arrays and return as string and grab first element to use for queue name and system id
			const queueName =
				newRow.Cells['Queue Name'].Value.split(',').map(String)[0];

			const systemID =
				newRow.Cells['WorkQueueID'].Value.split(',').map(String)[0];

			history.replace({
				pathname: `/workqueue/Request/${newRow.Cells['Tracking Number'].Value}`,
				search: `?TrackingNumber=${newRow.Cells['Tracking Number'].Value}&SystemName=${queueName}&SystemID=${systemID}`,
				state: newState,
			});
		}
	};

	return (
		<>
			<Grid
				container
				direction='row'
				justifyContent='center'
				sx={{ margin: '5px' }}
				spacing={1}
			>
				<Grid item>
					<Button
						startIcon={<ArrowBackwardIosNewIcon />}
						raised
						disabled={
							requestIndex === 0 ||
							workQueueRows.length === 0 ||
							(workQueueRows.length === 1 && requestIndex === 0)
						}
						onClick={() => handlePrevNext('prev')}
					>
						Previous Request
					</Button>
				</Grid>
				<Grid item>
					<Button raised onClick={() => history.goBack()}>
						Go Back to Work Queue
					</Button>
				</Grid>
				<Grid item>
					<Button
						endIcon={<ArrowForwardIosNewIcon />}
						raised
						disabled={
							(requestIndex === workQueueRows.length - 1 &&
								workQueueRows.length !== 1) ||
							workQueueRows.length === 0 ||
							workQueueRows.length === 1 ||
							requestIndex === -1
							// || (workQueueRows.length === 1 && requestIndex === 0)
						}
						onClick={() => handlePrevNext('next')}
					>
						Next Request
					</Button>
				</Grid>
			</Grid>
		</>
	);
};

export default RequestProcessing;
